<template>
  <div class="about">
    <h1>This is just a page inside a screen</h1>
  </div>
</template>
